export default __webpack_public_path__ + "static/media/footer.56f240e5.svg";